import { Div } from '@kizi/core-components';
import { Accordion, TabView } from '@kizi/shared-components';
import React, { MouseEventHandler } from 'react';
import { ProductProps } from '../..';
import { COMPARATOR_TYPE } from '../../../funnels';
import { PriceMode } from '../../../utils/product';
import { getExpandedData } from './functions';

interface ExpandedPartProps
  extends Omit<ProductProps, 'priceMode' | 'nextIndex'> {
  onTabChange: Function;
  priceMode: PriceMode;
  setModalTab0: MouseEventHandler;
  setModalTab1: MouseEventHandler;
  setModalTab2: MouseEventHandler;
  setModalTab3: MouseEventHandler;
  selectedTabIndex: number;
  startIndex: number;
  purchasableProduct: boolean;
}

export function getTabsTitles(type: string | undefined): string[] {
  if (type === COMPARATOR_TYPE.ENERGY) {
    return [
      'Over leverancier',
      'Productdetails',
      'Tarieven',
      'Over je aanvraag',
    ];
  } else {
    return [
      'Over verzekeraar',
      'Vergoedingen',
      'Premieopbouw',
      'Beoordelingen',
      'Over je aanvraag',
    ];
  }
}

export const ExpandedPart: React.FC<ExpandedPartProps> = ({
  data,
  onTabChange,
  priceMode,
  setModalTab0,
  setModalTab1,
  setModalTab2,
  selectedTabIndex,
  startIndex,
  purchasableProduct,
}: ExpandedPartProps) => {
  const { type } = data;

  const tabsTitles = getTabsTitles(type);

  const expandedData = getExpandedData(
    data,
    priceMode,
    setModalTab0,
    setModalTab1,
    setModalTab2,
  );

  const getTabs = (): { label: string; content: JSX.Element }[] => {
    const result = [
      {
        label: tabsTitles[0],
        content: expandedData[0].content,
      },
      { label: tabsTitles[1], content: expandedData[1].content },
      { label: tabsTitles[2], content: expandedData[2].content },
    ];
    if (purchasableProduct) {
      result.push({ label: tabsTitles[3], content: expandedData[3].content });
    }
    return result;
  };

  return (
    <>
      <Div
        className="expandedPart"
        display="flex"
        flexDirection="column"
        px={[3, null, 5]}
      >
        <Div className="mobile" display={[null, null, 'none']}>
          <Div>
            <Accordion
              allowOneItemOpen={true}
              items={expandedData}
              variant="accordionProductMobile"
            />
          </Div>
        </Div>
        <Div className="desktop" display={['none', null, 'initial']}>
          <Div className="separator" />
          <TabView
            display="flex"
            flexDirection="column"
            selectedTabIndex={
              selectedTabIndex === 0 ? undefined : selectedTabIndex
            }
            startIndex={startIndex}
            tabs={getTabs()}
            tabProps={(selected) => ({
              variant: `tabViewTab${selected ? 'Selected' : ''}`,
            })}
            onTabChange={onTabChange}
          >
            {(Tabs, Content) => {
              return (
                <>
                  <Div variant="tabViewTabsContainer">{Tabs}</Div>
                  <Div variant="tabViewContent">{Content}</Div>
                </>
              );
            }}
          </TabView>
        </Div>
      </Div>
    </>
  );
};

export { ContractSwitchFaq } from './ContractSwitchFaq';
export { ListComp } from './List';
export { MoreInfoButton } from './MoreInfoButton';
export { PackageComp } from './Package';
export { PackageInformation } from './PackageInformation';
export { ReviewsFC } from './Reviews';
export {
  getCharacteristics,
  getContractSwitchFaqMockData,
  getMockTimelineItems,
} from './functions';
